var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#008CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.711 20.722H7.278a1 1 0 01-1-1v-14a1 1 0 011-1H9.71C9.711 5.704 10.736 6.5 12 6.5s2.289-.796 2.289-1.778h2.433a1 1 0 011 1v14a1 1 0 01-1 1H14.29c0-.982-1.025-1.778-2.289-1.778-1.264 0-2.289.796-2.289 1.778zm2.145-10.566l.001 5.344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.482 13.78l2.044 2.044c.139.14.365.14.504 0l2.04-2.044"
  }))));
}
export default SvgDownload;